module.exports = __webpack_public_path__ + "img/Configuration.a9250d04.svg";